<template>
  <div>
    <a id="download-hyperlink"></a>

    <vk-card>
      <h1>Download CSV</h1>

      <div class="uk-grid" uk-grid>
        <div class="uk-width-1-2">
          <p>
            Comporre una query con i campi a destra per effettuare il download di un file CSV con i dati voluti, quindi
            cliccare sul pulsante qui sotto per avviare la procedura.
          </p>
          <p>
            La creazione del file CSV può richiedere qualche secondo se la query è molto grossa, cercare quindi 
            di richiedere solo i dati necessari. Per query inferiori a ~50 mila record tipicamente non ci sono problemi.
          </p>
          <vk-button size="large" type="primary" @click="downloadCSV" :disabled="downloading">
            <template v-if="!downloading">
              <vk-icon icon="download"></vk-icon> CSV
            </template>
            <template v-else>
              <vk-spinner></vk-spinner> Creazione in corso...
            </template>
          </vk-button>
        </div>
        <div class="uk-width-1-2">
          <QueryForm @input="queryChanged" :defaultNoneSelected="true"/>
        </div>
      </div>
    </vk-card>
  </div>
</template>

<style lang="scss">
  #download-hyperlink {
    display: none;
  }

  .device_id {
    font-family: monospace;
    font-size: 0.9em;
  }

  .device_label {
    font-weight: bold;
  }
</style>

<script>
import QueryForm from '@/components/QueryForm.vue'
import config from '@/config'

export default {
  name: 'csv',

  components: { QueryForm },

  beforeCreate () {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login')
    }
  },

  data () {
    return {
      currentQuery: {
        from: 0,
        to: 0,
        deviceFilter: []
      },
      downloading: false
    }
  },

  methods: {
    queryChanged (query) {
      this.currentQuery = query
    },

    downloadCSV () {
      this.downloading = true

      const maxSizeForBase64 = 1024 * 1024 // = 1MB
      const query = this.currentQuery

      let request = {
        from: query.from,
        to: query.to
      }

      if (query.deviceFilter.length > 0)
        request.devices = query.deviceFilter.join(',')

      this.$http.get(config.API_URL + '/csv', {
        params: request,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then(
        (response) => {
          if (response.body != null) {
            this.downloading = false

            var str = response.body

            var anchor = document.getElementById('download-hyperlink')
            var windowUrl = window.URL || window.webkitURL
            if (str.length > maxSizeForBase64 && typeof windowUrl.createObjectURL === 'function') {
                var blob = new Blob([response.body], { type: 'text/csv' })
                var url = windowUrl.createObjectURL(blob)
                anchor.href = url
                anchor.download = "tabulato.csv"
                anchor.click()
                windowUrl.revokeObjectURL(url)
            }
            else {
                //use base64 encoding when less than set limit or file API is not available
                anchor.href = 'data:text/csv;base64,' + window.btoaUTF8(response.body)
                anchor.download = 'tabulato.csv'
                anchor.click()
            }
          }
        }, (err) => {
          this.downloading = false

          console.log(err)
        }
      )
    }
  }
}
</script>
